import { searchKeyTypes as actionTypes } from '@actions';
import { commonState, commonReducer } from '@dotone/react-ui-core/helpers';

const defaultState = {
  ...commonState.default(),
};

export const searchKeyCreate = (state = defaultState, action) =>
  commonReducer(actionTypes.CREATE, state, action);
